import React, { Component } from 'react'
import styled from 'styled-components'

import { unitCurrency } from 'utils'

import IcBackArrow from './images/ic-arrow-back.component.svg'
import IcInvoice from './images/ic-result.component.svg'
import HomeVector from './images/home_illustration.component.svg'
import SeeIcon from './images/ic-see.component.svg'
import EditIcon from './images/ic-edit.component.svg'
import WhatsappIcon from './images/ic-whatsapp.component.svg'
import FacebookIcon from './images/ic-facebook.component.svg'
import XIcon from './images/ic-x.component.svg'
import MailIcon from './images/ic-mail.component.svg'
import CarLine from './images/car_line.component.svg'
import EnergyLine from './images/energy_line.component.svg'
import GasLine from './images/gas_line.component.svg'
import IcInfo from './images/ic-info.component.svg'

import ShareButtonV2 from '../ShareButtonV2'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import EnergyDetailsV2 from '../EnergyDetailsV2'
import DropdownGhostV2 from '../DropdownGhostV2'
import TooltipV2 from '../TooltipV2'
import EditDataModalV2 from '../EditDataModalV2'

export default class MyTarifSectionV2 extends Component {
  state = {
    shareUrl: `${window.location.origin}${window.location.pathname}?code=${this.props.code}`,
    shareContent: 'Veja a minha simulação em',
  }

  renderDataModal() {
    const { dataModal, toggleDataModal } = this.props

    return dataModal ? (
      <EditDataModalV2
        {...this.props}
        onClose={toggleDataModal}
        modalTriggerHeight={this.props.modalTriggerHeight}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
      />
    ) : null
  }

  renderContent(hasSimulation, content, aditionalCondition = true) {
    return hasSimulation && aditionalCondition ? content : null
  }

  handleChangeSimulationData = () => {
    const {
      router,
      changeSimulationData,
      resetFilters,
      setSearchQuery,
    } = this.props

    resetFilters()
    setSearchQuery('')
    changeSimulationData()
    router.push('/')
  }

  render() {
    const {
      hasSimulation,
      annualBilling,
      electricityPriceList,
      electricityConsumption,
      gasPriceList,
      gasConsumption,
      simulationCode,
      prices,
      code,
      className,
      toggleDataModal,
      simulationValues,
      ...restProps
    } = this.props

    return (
      <Wrapper className={className} {...restProps}>
        <TitleRow>
          <TitleLeft>
            <IcBackArrow onClick={this.handleChangeSimulationData} />
            <h1>O meu Tarifário</h1>
            <span>
              <p>simulação</p>
              {this.renderContent(hasSimulation, <p>{code}</p>)}
            </span>
          </TitleLeft>
          <ShareWrapper>
            <DropdownGhostV2 titleArea={<ShareButtonV2 title='Partilhar' />}>
              <div style={{ width: '186px', border: '1px solid #ECECEC' }}>
                <ShareBtn
                  href={`https://wa.me/?text=${encodeURIComponent(
                    this.state.shareContent
                  )} ${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.code}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <WhatsappIcon />
                  <p>Whatsapp</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.code}`
                  )}&quote=${encodeURIComponent(this.state.shareContent)}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <FacebookIcon />
                  <p>Facebook</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
                    this.state.shareContent
                  )}&url=${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.code}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <XIcon />
                  <p>X</p>
                </ShareBtn>
                <ShareBtn
                  noBorder
                  href={`mailto:?subject=${encodeURIComponent(
                    'Simulação'
                  )}&body=${encodeURIComponent(
                    `${this.state.shareContent} ${window.location.origin}${window.location.pathname}?code=${this.props.code}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <MailIcon />
                  <p>Mail</p>
                </ShareBtn>
              </div>
            </DropdownGhostV2>
          </ShareWrapper>
        </TitleRow>
        <Content>
          <InvoiceSection>
            <VectorWrapper>
              <HomeVector />
              {simulationValues.hasElectricCar ? (
                <VectorCarLine>
                  <CarLine />
                </VectorCarLine>
              ) : null}
              {simulationValues.hasNaturalGasHeating ? (
                <VectorGasLine>
                  <GasLine />
                </VectorGasLine>
              ) : null}
              {simulationValues.hasSolarSystem ? (
                <VectorEnergyLine>
                  <EnergyLine />
                </VectorEnergyLine>
              ) : null}
            </VectorWrapper>
            <InvoiceDetails>
              <span>
                <IcInvoice />
                <p>Fatura</p>
                <TooltipV2
                  content={
                    <TooltipText>Valores aproximados médios</TooltipText>
                  }
                  arrowLocation='topLeft'>
                  <IcInfo width={14} height={14} />
                </TooltipV2>
              </span>
              <Details>
                {this.renderContent(
                  hasSimulation,
                  <Detail>
                    <p>Custo Mensal</p>
                    <h3>
                      {annualBilling && unitCurrency(annualBilling / 12)}€
                    </h3>
                  </Detail>
                )}
                {this.renderContent(
                  hasSimulation,
                  <Detail>
                    <p>Custo Anual</p>
                    <h3>{annualBilling && unitCurrency(annualBilling)}€</h3>
                  </Detail>
                )}
              </Details>
            </InvoiceDetails>
          </InvoiceSection>

          {this.renderContent(
            hasSimulation,
            <EnergyDetailsV2 energyType='electricity' {...this.props} />,
            electricityPriceList
          )}

          {this.renderContent(
            hasSimulation,
            <EnergyDetailsV2 energyType='gas' {...this.props} />,
            gasPriceList
          )}

          <BtnsWrapper>
            <ButtonOutlineV2
              onClick={() => {
                window.open(
                  'https://www.poupaenergia.pt/fatura-energia/',
                  '_blank',
                  'noopener,noreferrer'
                )
              }}
              icon={<SeeIcon />}>
              Como ler a fatura
            </ButtonOutlineV2>
            <TooltipV2
              style={{ width: '100%' }}
              contentStyle={{
                minWidth: '220px',
              }}
              dialogStyle={{
                marginTop: '10px',
              }}
              content={
                <TooltipText>
                  Clique para atualizar os valores da sua simulação com a
                  possibilidade de inserir os dados da sua fatura.
                </TooltipText>
              }
              arrowLocation='topLeft'>
              <ButtonGradientV2
                setModalTriggerHeight={this.props.setModalTriggerHeight}
                onClick={toggleDataModal}
                icon={<EditIcon />}>
                Ajustar Valores
              </ButtonGradientV2>
            </TooltipV2>
          </BtnsWrapper>
        </Content>
        {this.renderDataModal()}
      </Wrapper>
    )
  }
}

const TooltipText = styled.h6`
  color: #fff;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  min-width: 160px;
  margin: 0;
`

const VectorWrapper = styled.div`
  flex: 1 0 0;
  position: relative;
`

const VectorCarLine = styled.div`
  position: absolute;
  top: 17%;
  left: 9%;
`

const VectorGasLine = styled.div`
  position: absolute;
  right: 14%;
  top: 30%;
`

const VectorEnergyLine = styled.div`
  position: absolute;
  top: 0;
  right: 27%;
`

const Wrapper = styled.div`
  display: flex;
  padding: 24px 20px;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  max-width: 1200px;
  margin-inline: auto;

  @media screen and (min-width: 1300px) {
    padding-inline: 0px;
  }
`

const TitleRow = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
`

const TitleLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch;

  svg {
    cursor: pointer;
  }

  h1 {
    color: #1d1e22;
    font-family: Nunito;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
    margin: 0;
  }

  span {
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background: linear-gradient(
        0deg,
        rgba(147, 193, 62, 0.1) 0%,
        rgba(147, 193, 62, 0.1) 100%
      ),
      #fff;

    p {
      color: #006736;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
      margin: 0;
    }

    p:last-child {
      font-weight: 700;
    }
  }
`

const ShareWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`

const Content = styled.div`
  display: flex;
  padding: 16px 16px 0px 16px;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
`

const InvoiceSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const InvoiceDetails = styled.div`
  display: flex;
  padding: 12px 16px 12px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-right: 1px solid #ececec;

  > span:first-child {
    display: flex;
    height: 20px;
    align-items: center;
    gap: 4px;
    align-self: stretch;

    p {
      color: #3e3e3e;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      margin: 0;

      b {
        font-weight: 400;
      }
    }

    > div {
      height: 19px;
    }
  }
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`

const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 10px;

  p,
  h3 {
    margin: 0;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
    font-weight: 400;
  }

  p {
    color: #676767;
  }

  h3 {
    color: #1d1e22;
    font-weight: 700;
  }
`

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  flex-grow: 1;
  max-width: 220px;
  margin-left: auto;
`

const ShareBtn = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  height: 40px;
  padding: 10px;
  border-bottom: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #ECECEC')};
  background: #fff;
  text-decoration: none;

  cursor: pointer;

  p {
    flex: 1 0 0;
    color: var(--Gray, #3e3e3e);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`



// WEBPACK FOOTER //
// ./src/components/MyTarifSectionV2/index.js